import Menu from './Menu'
import Input from './Input'
import Select from './Select'
import Divider from './Divider'
import Tabs from './Tabs'
import Badge from './Badge'
import Switch from './Switch'
import Checkbox from './Checkbox'
import Radio from './Radio'
import Table from './Table'
import Carousel from './Carousel'
import DatePicker from './DatePicker'
import Button from './Button'

import type { OverrideToken } from 'antd/es/theme/interface'

const components: OverrideToken = {
  Menu,
  Input,
  Select,
  Divider,
  Tabs,
  Badge,
  Switch,
  Checkbox,
  Radio,
  Table,
  Carousel,
  DatePicker,
  Button
} as const

export default components
